import React from 'react';
import validationRules from "../../validations/contactusvalidationrules.json";
import "../../styles/textinput.css";

const MultilineInput = ({ name, value, onChange, error, setError, minLength = 10 }) => {
  const handleBlur = (e) => {
    const messageRules = validationRules.message;
    let errorMessage = '';
    
    if (!e.target.value) {
      errorMessage = "Message is required";
    } else if (e.target.value.length < minLength) {
      errorMessage = messageRules.errorMessage;
    }
    
    setError(errorMessage);
  };

  return (
    <div className="form-group">
      <textarea
        name={name}
        placeholder="Message"
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
        rows={4}
        style={{
          resize: 'vertical',
          minHeight: '100px'
        }}
      />
      {error && <span className="error">{error}</span>}
    </div>
  );
};

export default MultilineInput; 